<script type="text/javascript">
  //兼容原来的写法，以后采用process.env.BASE_API来取全局变量
  const apiUrl = process.env.BASE_API
  const uploadUrl = process.env.UPLOAD_URL
  // 文件接口, 图片, 文档...
  const fileUrl = process.env.FILE_URL
  // 前端地址
  const htmlUrl = process.env.HTML_URL
  // 实时聊天连接地址
  const wsUrl = process.env.WS_URL

  // ----------------------------------------------------------------
  function commonFun() {
    console.log("公共方法")
  }
  // 暴露出这些属性和方法
  export default {
    apiUrl,
    uploadUrl,
    fileUrl,
    htmlUrl,
    wsUrl,
    commonFun
  }
</script>



// WEBPACK FOOTER //
// src/common/constant/constant.vue